import { Droppable } from '../components/Droppable'

import { AlphaTypes } from '../../custom-types'

export default function QuestionnaireOptions({
  components,
}: {
  components: AlphaTypes[]
}) {
  return (
    <Droppable
      id="templateContainer"
      items={components}
      renderItem={(field: AlphaTypes) => (
        <div className="mb-2 p-3 bg-white rounded-lg border border-border hover:border-blue-300 hover:shadow-sm transition-all cursor-grab flex items-center">
          <span className="mr-2 text-gray-400">⋮⋮</span>
          <span>
            {'uiOptions' in field &&
              field.uiOptions &&
              'label' in field.uiOptions
              ? field.uiOptions.label
              : 'name' in field
                ? field.name
                : 'Component'}
          </span>
        </div>
      )}
    />
  )
}
